import React, { ReactNode } from 'react';
import { Component } from 'puzzle';
import { GLOSSARY, TMS_SERVER } from "../../MultiBatchUpload/Types";
import { TM_CONFIG } from "../../../util/Util";

type PROPS = {
  glossaries: GLOSSARY[]
  translationMemories: TMS_SERVER[],
  tmConfigurationData: TM_CONFIG
}

class TmConfiguration extends Component<PROPS, {}> {
  /**
   * Get glossaries element
   */
  getGlossaries = (): ReactNode => {
    const { glossaries } = this.props;
    let element: ReactNode = null;

    if (glossaries?.length) {
      const { tmgrServerUrl } = glossaries[0];
      element = <>
        <span>{this.translate('glossaryString', { glossaryString: tmgrServerUrl })}</span>
      </>
    }

    return element;
  };

  /**
   * Get tm config element
   */
  getTmConfig = (): ReactNode => {
    const { translationMemories, tmConfigurationData } = this.props;
    let element: ReactNode = null;
    if (translationMemories?.length) {
      const { targetLanguage, sourceLanguagePair } = tmConfigurationData;
      const defaultTM = translationMemories.find((item: any) => {
        return item.languages.find((langItem: any) => langItem.sourceLanguageId === sourceLanguagePair && langItem.targetLanguageId === targetLanguage && langItem.default)
      })
      const tmName = defaultTM?.tmName;
      const tmUrls = defaultTM?.tmUrls || [];
      element = <>
        <span>{this.translate('tmProfileName', { tmName })}</span>
        <span>{this.translate('tmProfileString', { tmString: tmUrls[0] })}</span>
      </>;
    }

    return element;
  };

  render() {
    return (
      <div>
        <h3>{this.translate('defaultTMConfiguration')}</h3>
        <div className={'k-vbox'}>
          {this.getTmConfig()}
          {this.getGlossaries()}
        </div>
      </div>
    );
  }
}

export default TmConfiguration;
